/* eslint-disable react/prop-types */
import React from 'react';
import { Icon } from 'components/v3';

// Orange ghost "expand to modal" button. Tile styling from the scoped
// `.expand-btn` rule in styles.js; glyph via the v3 Icon set.
const ExpandButton = ({ onClick, title = 'Expand' }) => (
  <button type="button" className="expand-btn" onClick={onClick} title={title}>
    <Icon name="maximize-2" size={18} strokeWidth={2.8} />
  </button>
);

export default ExpandButton;
